// constants/datosLocales.js

export const datosLocales = {
  'local-vitacura': {
    texto_superior: "BIENVENIDOS A",
    texto_inferior: "Nuestro equipo de expertos está listo para atender todas sus consultas.",
    numero_local: "tel:225805050",
    imagen_logo: "/img/home/nuestros_locales/vitacura/logo.svg",
  },
  'local-vina': {
    texto_superior: "BIENVENIDOS A",
    texto_inferior: "Nuestro equipo de expertos está listo para atender todas sus consultas.",
    numero_local: "tel:225805025",
    imagen_logo: "/img/home/nuestros_locales/vina/logo.svg",
  },
  'local-vicmack': {
    texto_superior: "BIENVENIDOS A",
    texto_inferior: "Nuestro equipo de expertos está listo para atender todas sus consultas.",
    numero_local: "tel:225805044",
    imagen_logo: "/img/home/nuestros_locales/vicmack/logo.svg",
  },
  'local-rancagua': {
    texto_superior: "BIENVENIDOS A",
    texto_inferior: "Nuestro equipo de expertos está listo para atender todas sus consultas.",
    numero_local: "tel:225805025",
    imagen_logo: "/img/home/nuestros_locales/rancagua/logo.svg",
  },
  'local-puertomontt': {
    texto_superior: "BIENVENIDOS A",
    texto_inferior: "Nuestro equipo de expertos está listo para atender todas sus consultas.",
    numero_local: "tel:225805055",
    imagen_logo: "/img/home/nuestros_locales/puertomontt/logo.svg",
  },
  'local-penalolen': {
    texto_superior: "BIENVENIDOS A",
    texto_inferior: "Nuestro equipo de expertos está listo para atender todas sus consultas.",
    numero_local: "tel:225805002",
    imagen_logo: "/img/home/nuestros_locales/penalolen/logo.svg",
  },
  'local-maipu': {
    texto_superior: "BIENVENIDOS A",
    texto_inferior: "Nuestro equipo de expertos está listo para atender todas sus consultas.",
    numero_local: "tel:225805027",
    imagen_logo: "/img/home/nuestros_locales/maipu/logo.svg",
  },
  'local-laserena': {
    texto_superior: "BIENVENIDOS A",
    texto_inferior: "Nuestro equipo de expertos está listo para atender todas sus consultas.",
    numero_local: "tel:225805061",
    imagen_logo: "/img/home/nuestros_locales/laserena/logo.svg",
  },
  'local-laflorida': {
    texto_superior: "BIENVENIDOS A",
    texto_inferior: "Nuestro equipo de expertos está listo para atender todas sus consultas.",
    numero_local: "tel:225805016",
    imagen_logo: "/img/home/nuestros_locales/laflorida/logo.svg",
  },
  'local-irarrazaval': {
    texto_superior: "BIENVENIDOS A",
    texto_inferior: "Nuestro equipo de expertos está listo para atender todas sus consultas.",
    numero_local: "tel:225805080",
    imagen_logo: "/img/home/nuestros_locales/irarrazaval/logo.svg",
  },
  'local-estoril': {
    texto_superior: "BIENVENIDOS A",
    texto_inferior: "Nuestro equipo de expertos está listo para atender todas sus consultas.",
    numero_local: "tel:225805090",
    imagen_logo: "/img/home/nuestros_locales/estoril/logo.svg",
  },
  'local-diagonal': {
    texto_superior: "BIENVENIDOS A",
    texto_inferior: "Nuestro equipo de expertos está listo para atender todas sus consultas.",
    numero_local: "tel:56225805070",
    imagen_logo: "/img/home/nuestros_locales/diagonal/logo.svg",
  },
  'local-concepcion': {
    texto_superior: "Nos renovamos por ti, bienvenidos a",
    texto_inferior: "Nos encontrarás a pocos pasos, con un local más cómodo y moderno",
    numero_local: "tel:225805045",
    imagen_logo: "/img/home/nuestros_locales/concepcion/logo.svg",
  },
  'local-colon': {
    texto_superior: "BIENVENIDOS A",
    texto_inferior: "Nuestro equipo de expertos está listo para atender todas sus consultas.",
    numero_local: "tel:225805060",
    imagen_logo: "/img/home/nuestros_locales/colon/logo.svg",
  },
  'local-chicureo': {
    texto_superior: "BIENVENIDOS A",
    texto_inferior: "Nuestro equipo de expertos está listo para atender todas sus consultas.",
    numero_local: "tel:225805029",
    imagen_logo: "/img/home/nuestros_locales/chicureo/logo.svg",
  },
  'local-antofagasta': {
    texto_superior: "BIENVENIDOS A",
    texto_inferior: "Nuestro equipo de expertos está listo para atender todas sus consultas.",
    numero_local: "tel:225805015",
    imagen_logo: "/img/home/nuestros_locales/antofagasta/logo.svg",
  },
}